import { connect } from 'react-redux';

import * as CliApp from 'app/entities/CliApp';
import * as CliAppDefinition from 'app/entities/CliAppDefinition';
import * as DeveloperActions from 'app/developer-v3/Actions';
import LoadingBlockOrComponent from 'app/common/components/LoadingBlockOrComponent';
import hocify from 'app/common/components/hocify';
import {
  currentAppDefinitionEntity,
  currentDefinition,
  currentDefinitionOverride,
} from 'app/developer-v3/selectors';
import { selectAppId } from 'app/developer-v3/store/selectors';

import IssueList from './IssueList';

const mapStateToProps = state => {
  const appId = selectAppId(state);
  const appDefinitionEntity = currentAppDefinitionEntity(state);

  // Triggers and actions are stored in different places for CLI apps and UI apps
  // UI apps -> data.definition_override
  // CLI apps -> data.definition
  //
  // TODO: This is fetching triggers and actions of the opened version in the
  // UI. We should relaly fetch the version in public. It'll be consistent with
  // Loki.
  const definition = appDefinitionEntity?.data?.is_ui
    ? currentDefinitionOverride(state)
    : currentDefinition(state);
  const triggers = definition?.triggers || {};
  const actions = {
    ...(definition?.creates || {}),
    ...(definition?.searches || {}),
  };

  return {
    actions,
    isLoading:
      CliApp.selectors.all.isLoadingById(appId, state) ||
      CliAppDefinition.selectors.all.isLoadingById(appId, state),
    triggers,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    async onLoad() {
      const { id } = props.params;
      const { version } = props.appSummary;
      return await dispatch(DeveloperActions.loadAppAndVersion(id, version));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(hocify(LoadingBlockOrComponent)(IssueList));
